import { render, staticRenderFns } from "./DementiaTreatment.vue?vue&type=template&id=560a26c6"
import script from "./DementiaTreatment.vue?vue&type=script&lang=js"
export * from "./DementiaTreatment.vue?vue&type=script&lang=js"
import style0 from "./DementiaTreatment.vue?vue&type=style&index=0&id=560a26c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports